import {
  GET_USER_REPORT,
  GET_USER_REPORT_SUCCESS,
  GET_USER_REPORT_FAILED,
  FETCH_TRAINED_SENTENCE_COUNT_REPORT,
  FETCH_TRAINED_SENTENCE_COUNT_REPORT_SUCCESS,
  FETCH_TRAINED_SENTENCE_COUNT_REPORT_FAILED,
  FETCH_TRANSCRIPTED_SENTENCE_COUNT_REPORT,
  FETCH_TRANSCRIPTED_SENTENCE_COUNT_REPORT_SUCCESS,
  FETCH_TRANSCRIPTED_SENTENCE_COUNT_REPORT_FAILED,
  FETCH_COMPARED_STATISTIC_REPORT,
  FETCH_COMPARED_STATISTIC_REPORT_SUCCESS,
  FETCH_COMPARED_STATISTIC_REPORT_FAILED,
  DOWNLOAD_HOURLY_REPORT,
  DOWNLOAD_HOURLY_REPORT_SUCCESS,
  DOWNLOAD_HOURLY_REPORT_FAILED,
  DOWNLOAD_RECORDING_PENDING_REPORT,
  DOWNLOAD_RECORDING_PENDING_REPORT_SUCCESS,
  DOWNLOAD_RECORDING_PENDING_REPORT_FAILED,
  DOWNLOAD_CSV_FILE,
  DOWNLOAD_CSV_FILE_SUCCESS,
  DOWNLOAD_CSV_FILE_FAILED,
  FETCH_SPECIFIC_AUDIO,
  FETCH_SPECIFIC_AUDIO_SUCCESS,
  FETCH_SPECIFIC_AUDIO_FAILED,
  GET_TRANSCRIPT_LIST_TO_BE_RECORDED,
  GET_TRANSCRIPT_LIST_TO_BE_RECORDED_SUCCESS,
  GET_TRANSCRIPT_LIST_TO_BE_RECORDED_FAILED,
} from "./../constants/constants";

const initialState = {
  userReport: [],
  overallReport: {
    trainedSentenceCount: [],
    transcriptedSentenceCount: [],
    compareStatsCount: [],
  },
  currentFile: {
    id: null,
    filePath: null,
  },
  transcriptToBeRecorded: {
    data: [],
  },
  downloadReport: {
    loading: null,
    status: null,
  },
  loading: true,
};

const AdminDashBoard = (state = initialState, action) => {
  let { overallReport, downloadReport } = state;
  switch (action.type) {
    case GET_USER_REPORT:
      return {
        ...state,
        currentFile: {
          id: null,
          filePath: null,
        },
        loading: true,
      };
    case GET_USER_REPORT_SUCCESS:
      return {
        ...state,
        userReport: action.data,
        loading: false,
      };
    case GET_USER_REPORT_FAILED:
      return {
        ...state,
        loading: true,
      };

    case FETCH_TRAINED_SENTENCE_COUNT_REPORT:
      return {
        ...state,
      };

    case FETCH_TRAINED_SENTENCE_COUNT_REPORT_SUCCESS:
      overallReport.trainedSentenceCount = action.data;

      return {
        ...state,
        overallReport,
      };
    case FETCH_TRAINED_SENTENCE_COUNT_REPORT_FAILED:
      return {
        ...state,
      };

    case FETCH_TRANSCRIPTED_SENTENCE_COUNT_REPORT:
      //Doubt
      return {
        ...state,
      };
    case FETCH_TRANSCRIPTED_SENTENCE_COUNT_REPORT_SUCCESS:
      overallReport.transcriptedSentenceCount = action.data;
      return {
        ...state,
        overallReport,
      };
    case FETCH_TRANSCRIPTED_SENTENCE_COUNT_REPORT_FAILED:
      return {
        ...state,
      };

    case FETCH_COMPARED_STATISTIC_REPORT:
      return {
        ...state,
      };
    case FETCH_COMPARED_STATISTIC_REPORT_SUCCESS:
      overallReport.compareStatsCount = action.data;
      return {
        ...state,
        overallReport,
      };
    case FETCH_COMPARED_STATISTIC_REPORT_FAILED:
      return {
        ...state,
      };

    case FETCH_SPECIFIC_AUDIO:
      return {
        ...state,

        currentFile: {
          id: null,
          filePath: null,
        },
        loading: true,
      };

    case FETCH_SPECIFIC_AUDIO_SUCCESS:
      return {
        ...state,
        currentFile: {
          id: action.data[0].id,
          filePath: action.data[0].filepath,
        },
      };
    case FETCH_SPECIFIC_AUDIO_FAILED:
      return {
        ...state,
      };

    case GET_TRANSCRIPT_LIST_TO_BE_RECORDED:
      return {
        ...state,
        loading: true,
      };
    case GET_TRANSCRIPT_LIST_TO_BE_RECORDED_SUCCESS:
      //console.log(action.data.slice(0,2))
      return {
        ...state,
        loading: false,
        transcriptToBeRecorded: {
          /*data: action.data.length === 0 ? [] 
              : action.data.length <= 9 ? action.data 
              : action.data.slice(0,9) */
          data: action.data,
        },
      };
    case GET_TRANSCRIPT_LIST_TO_BE_RECORDED_FAILED:
      return {
        ...state,
      };
    case DOWNLOAD_HOURLY_REPORT:
      downloadReport.loading = true;
      return {
        ...state,
        downloadReport,
      };
    case DOWNLOAD_CSV_FILE:
      downloadReport.loading = true;
      return {
        ...state,
        downloadReport,
      };
    case DOWNLOAD_CSV_FILE_SUCCESS:
      downloadReport.loading = false;
      return {
        ...state,
        downloadReport,
      };
    case DOWNLOAD_RECORDING_PENDING_REPORT:
      downloadReport.loading = true;
      return {
        ...state,
        downloadReport,
      };
    case DOWNLOAD_RECORDING_PENDING_REPORT_SUCCESS:
      downloadReport.loading = false;
      return {
        ...state,
        downloadReport,
      };
    case DOWNLOAD_HOURLY_REPORT_SUCCESS:
      downloadReport.loading = false;
      return {
        ...state,
        downloadReport,
      };
    default:
      return state;
  }
};
export default AdminDashBoard;
